import { FormName } from '@core/data-access/models/form/form.model';
import { FormFieldSyncActions } from '@core/data-access/store/form/form.actions';
import { setFormFields } from '@core/data-access/store/form/form.reducer';
import { AnonymousVoucherActions } from '@core/data-access/store/shared/shared.actions';
import { BuyerQuestionnaireStoreState } from '@core/features/buyer-questionnaire/models/buyer-questionnaire-store.model';
import {
  BuyerQuestionnaireActions,
  BuyerQuestionnaireDynamicFieldsActions
} from '@core/features/buyer-questionnaire/store/buyer-questionnaire.actions';
import { createReducer, on } from '@ngrx/store';
import { isEmpty } from 'lodash';

export const buyerQuestionnaireReducerKey = 'buyerQuestionnaire';

export const initialBuyerQuestionnaireStoreState: BuyerQuestionnaireStoreState = {
  dynamicFields: {
    [FormName.BuyerQuestionnaire]: []
  },
  forms: {
    [FormName.BuyerQuestionnaire]: {
      formFields: {}
    }
  }
};

export const buyerQuestionnaireReducer = createReducer(
  initialBuyerQuestionnaireStoreState,
  on(
    BuyerQuestionnaireDynamicFieldsActions.setBuyerQuestionnaireDynamicFields,
    (state, { dynamicBuyerQuestionnaireFields }) => {
      if (isEmpty(dynamicBuyerQuestionnaireFields)) {
        return state;
      }

      return {
        ...state,
        dynamicFields: {
          ...state.dynamicFields,
          [FormName.BuyerQuestionnaire]: dynamicBuyerQuestionnaireFields
        }
      };
    }
  ),
  on(BuyerQuestionnaireDynamicFieldsActions.resetBuyerQuestionnaireDynamicFields, (state) => ({
    ...state,
    dynamicFields: {
      ...state.dynamicFields,
      [FormName.BuyerQuestionnaire]: []
    }
  })),
  on(FormFieldSyncActions.setBuyerQuestionnaireFormFields, (state, { formFields }) =>
    setFormFields(state, formFields, FormName.BuyerQuestionnaire, true)
  ),
  on(AnonymousVoucherActions.resetStateOnAnonymousVoucherRedeem, (state) => ({
    ...state,
    dynamicFields: { ...state.dynamicFields }
  })),
  on(BuyerQuestionnaireActions.resetReducer, () => initialBuyerQuestionnaireStoreState)
);
